(function () {
hubspot.define('hubspot.embedding.apps.dialog', ['jQuery', 'q/js/lib/defer', 'vex', 'hubspot.embedding.common', 'hubspot.embedding.host'], function($, defer, vex, common, embedHost) {
  var openDialog;
  openDialog = function(appElId, appChannelId, url, css, appParams, origin, vexOptions) {
    var $vexContent, appLifetime, embeddedAppContent, handleAppClose, handleAppOpen, template, vexId;
    if (css == null) {
      css = {};
    }
    if (vexOptions == null) {
      vexOptions = {};
    }
    template = jade.templates.embeddedAppIframe;
    embeddedAppContent = template({
      url: url,
      id: appElId,
      extraStyles: 'border:none; border-radius: 5px;'
    });
    appLifetime = defer();
    vexId = null;
    handleAppOpen = function() {
      var innerWindow;
      innerWindow = $("#" + appElId)[0].contentWindow;
      return embedHost.waitForAppReady({
        targetWindow: innerWindow,
        channel: appChannelId,
        origin: origin
      }).then(function() {
        vex.hideLoading();
        return embedHost.startApp({
          channel: appChannelId,
          params: appParams
        });
      }).then(function(messageInfo) {
        appLifetime.resolve(messageInfo.message.data.params);
        return vex.closeByID(vexId);
      }).done();
    };
    handleAppClose = function() {
      appLifetime.resolve({
        closeEvent: 'cancel'
      });
      return vex.hideLoading();
    };
    vex.showLoading();
    _(vexOptions).extend({
      content: embeddedAppContent,
      afterOpen: handleAppOpen,
      afterClose: handleAppClose
    });
    if (vex.defaultOptions.contentCSS != null) {
      vexOptions.contentCSS = css;
    } else {
      vexOptions.css = css;
    }
    $vexContent = vex.open(vexOptions);
    vexId = $vexContent.data().vex.id;
    return appLifetime.promise;
  };
  return {
    openDialog: openDialog
  };
});
}());

